const elem = document.querySelector(".js-chapter-slider-slides");
const nextButton = document.querySelector(".js-chapter-slider-next-btn");
const prevButton = document.querySelector(".js-chapter-slider-prev-btn");

if (typeof elem != "undefined" && elem != null) {
    var flkty = new Flickity(elem, {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
    });

    prevButton.addEventListener("click", function () {
        flkty.previous();
    });
    nextButton.addEventListener("click", function () {
        flkty.next();
    });
}
